import CatalogBackgroundGradient from '@/catalog/components/catalog-background-gradient';
import CatalogContentContainer from '@/catalog/components/catalog-content-container';
import { CatalogLoader } from '@/catalog/types/catalog-loader';
import defaultMarketRedirect from '@/catalog/utils/actions/default-market-redirect';
import { redirectMismatchedMarket } from '@/catalog/utils/actions/redirect-mismatched-market';
import PageErrorBanners from '@/common/components/page-error-banners';
import PageLayout from '@/common/components/page-layout';
import { appFetch } from '@/util-react-router/app-fetch';
import logResponseError from '@/util-react-router/log-response-error';
import { LoaderFunction, LoaderFunctionArgs, Outlet, useLoaderData } from 'react-router';

export const loader: LoaderFunction = async ({ request, params }: LoaderFunctionArgs) => {
  const response = await appFetch({
    url: `/api/external/v1/markets`,
    request,
  });

  if (!response.ok) {
    logResponseError('catalog root - markets - loader', response);
    return { errors: { error: 'Failed to fetch session' } };
  }

  const { session } = await response.json();
  const sessionMarketId = session?.cart?.market_id;

  // Default to new england market if zipcode driven inventory is enabled and no market in session
  if (!params.market && !sessionMarketId) {
    return defaultMarketRedirect({ request, response });
  }

  // If user has a selected market and is not already on the page, redirect

  const url = new URL(request.url);
  const searchParams = url.searchParams.toString();
  const redirect = redirectMismatchedMarket({
    sessionMarketId,
    paramMarketId: params.market,
    queryParams: searchParams,
    response,
  });

  if (redirect) {
    return redirect;
  }

  //  We have a market param, good to proceed to sub page
  // TODO: and NOTE: we have observed that removing loader data is causing cached page related issues for customers, these have been added to alleviate those errors. This  can be swapped back to `return null` at a future date.
  return { markets: [], session, ZIPCODE_DRIVEN_INVENTORY: true };
};

export default function InventoryRoot() {
  const loaderData = useLoaderData<CatalogLoader>();

  if (loaderData?.errors?.error) {
    return (
      <PageLayout
        backgroundColor="bg-none"
        headerSheetBackgroundColor="bg-flexcar-blue10"
        dark={true}
        disablePageContainer={true}
        disableFooterMargin={true}
        hideCatalogLink={true}
        headerContentSpacerVariant="height8"
      >
        <div className="relative flex w-full flex-col items-center">
          <CatalogBackgroundGradient />

          {loaderData?.errors ? (
            <CatalogContentContainer>
              <PageErrorBanners loaderErrors={loaderData?.errors} />
            </CatalogContentContainer>
          ) : null}
        </div>
      </PageLayout>
    );
  }

  return <Outlet />;
}
